<template>
  <!--
      作者 luoyiming
      时间：2020-06-09
      描述：会员-管理奖设置
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="资金池" name="first"></el-tab-pane>
      <el-tab-pane label="设置" name="second"></el-tab-pane>
    </el-tabs>
    <!--星级用户-->
    <List v-if="activeName == 'first'"></List>
    <!--管理奖设置-->
    <Setting v-if="activeName == 'second'"></Setting>
  </div>
</template>
<script>
import Setting from './Setting.vue';
import List from './list.vue';
export default {
  components: {
    Setting,
    List
  },
  data() {
    return {
      form: {
        status: 0
      },
      activeName: 'first'
    };
  },
  methods: {}
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/user/fundpool/index.vue